<template>
<div class="">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="mb-1">{{ title }}</h4>
      <slot name="actions" />
    </div>
    <hr v-if="border" class="bg-gray-400">
    <slot/>
</div>
</template>
<script setup>

const props = defineProps({
    title: {type: String},
    border: {type: Boolean, default: false}
})
</script>